import { useState } from 'react';

import { theme } from '../../../theme/theme';
import { Grid, Typography } from '@mui/material';
import SearchBar, { FilterSummaries, HasFilters } from '../SearchBar';
import CloudSystemGrid from '../CloudSystemGrid';

import { useGetCloudSystemSummariesQuery } from "../apiDashboard";

// JS doesn't have interfaces
//  use this commented out definition as a reference for the props that should be accepted for this component 
// export interface UncommissionedSummariesProps {
//   // No props for now
// }

const UncommissionedSummaries = (props) => {
  
  const [filters, setFilters] = useState(null); // string or object
  const [getTrigger, setGetTrigger] = useState(1); // Changing part of the object passed to the Redux hook triggers the query for subsequent calls

  const handleFiltersChanged = (filters /* object */) => {
    setFilters(filters);
  };

  const onNeedsGet = () => {
    setGetTrigger(g => (g === 1 ? 2 : 1)); // Changing the data will trigger GET call
  };

  const {
    data: summaries,
    isLoading,
    isSuccess,
    error,
  } = useGetCloudSystemSummariesQuery({type: "uncommissioned", trigger: getTrigger}, { pollingInterval: 10000, refetchOnMountOrArgChange: true, refetchOnFocus: true, refetchOnReconnect: true  });
  
  const filterApplied = HasFilters(filters)
  let filteredSummaries = FilterSummaries(summaries, filters)
  let errorMessage = error?.data?.error
  if (error && !errorMessage) {
    // We didn't get an actual error message, so generate one from the status code
    if (error?.status === 403) {
      errorMessage = 'Access forbidden. Your user account is likely not included in the appropriate group'
    } else if (error?.status === 500) {
      errorMessage = 'Internal server error'
    } else if (error?.status === 'FETCH_ERROR') {
      errorMessage = 'Failed to contact the server'
    } else {
      errorMessage = 'Unknown error'
    }
  }

  // Shift down whichever content comes after the SearchBar
  const contentTop = (80 /* NavBar height */ + 64 /* SearchBar height */);

  return (
    <>
      <SearchBar summaryType={"uncommissioned"} onFiltersChanged={handleFiltersChanged}/>
      <Grid container position={'fixed'} flex={1} flexDirection={'column'} sx={{top: contentTop, height: `calc(100vh - ${contentTop}px)`, overflowY: 'auto', backgroundColor: '#112334'}}>
        {isLoading ?
        (<>
          <Typography sx={{ p: 2, color: 'white' }}>
            Loading...
          </Typography>
        </>) :
        error ?
        (<>
          <Typography sx={{ p: 2,  color: 'white' }}>
            Error loading: {errorMessage}
          </Typography>
        </>) :
        // When GET is manually triggered, there is a brief moment where isLoading, isError, and isSuccess are not set. Retain summaries during this moment...
        isSuccess || filteredSummaries !== undefined ? 
        (<CloudSystemGrid summaries={filteredSummaries} cloudType={'uncommissioned'} filterApplied={filterApplied} filterTypes={filters?.filterTypes} onNeedsGet={onNeedsGet} />) :
        (<>
          <Typography sx={{ p: 2, color: 'white' }}>
            Not sure what happened
          </Typography>
        </>)}
      </Grid>
    </>
  );
};

export default UncommissionedSummaries;
